import React, { FC, useEffect, useState, useContext } from "react";
import { Checkbox, Icon, Table } from "semantic-ui-react";
import { IGrid, IGridField } from "../Interfaces/TableInterface";
import { FieldContext } from "../../contexts/FieldsContext";

 interface IProps {
    field: IGridField,
    showTableCol: boolean,
    showColWidth: boolean,
    callback: any,
}

export enum OrderMetaListType {
    Alias = 1,
    Width = 2,
}

const OrderMetaItem: FC<IProps> = ({ field, showTableCol, showColWidth,callback }) => {

    const { columnTotalWidth } = useContext(FieldContext);

    const [alias, setAlias] = useState<string>("");
    const [colWidth, setColWidth] = useState<number>(1);

    useEffect(() => {
        if (field.alias !== null &&  field.alias !== undefined) {
            setAlias(field.alias)
        }

        if (field.colWidth !== null && field.colWidth !== undefined) {
            setColWidth(field.colWidth)
        }
            
    }, [field]);


    useEffect(() => {
        if (field.colWidth !== null && field.colWidth !== undefined) {
            setColWidth(field.colWidth);
            // Explicitly trigger callback for initial setup
            callback(field, false);
        }
    }, [field]);

    useEffect(() => {
    
    }, [showColWidth]);


    const updateList = (data: string, type: OrderMetaListType) => {
        if (type === OrderMetaListType.Width) {
            let width = parseInt(data);
            field.colWidth = width;
            setColWidth(width);
        }

        if (type === OrderMetaListType.Alias) {
            field.alias = data;
            setAlias(data);
        }

        callback(field, false);
    }

    const deleteField = (field: IGridField) => {
        callback(field, true);
    }

    return (
        <>
            <Table.Cell>{field.name}</Table.Cell>
            {showTableCol &&
                <Table.Cell>
                    <div className="ui input">
                        <input id={field.name} type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Table Alias" value={alias} onChange={(e) => updateList(e.target.value, OrderMetaListType.Alias)} />
                    </div>
                </Table.Cell>
            }

            {showColWidth &&
                <Table.Cell>
                    <div className="ui input">
                        <input id={`${field.name}_width`} type="number" min={1} max={columnTotalWidth} style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Width" value={colWidth} onChange={(e) => updateList(e.target.value, OrderMetaListType.Width)} />
                    </div>
                </Table.Cell>
            }
            
            <Table.Cell><Icon name='trash alternate outline' className="ico-click" style={{ cursor: "pointer" }} onClick={() => { deleteField(field) }} /></Table.Cell>
        </>
    )
}

export default OrderMetaItem;